import { pathOr } from 'ramda';
import { useCallback, useMemo, useState } from 'react';
import { IBaseQuestionProps } from '../../FormContainer/types/internal';
import { PRICE_OPTIONS_FIELD } from '../constants';

export const usePriceOptions = (props: IBaseQuestionProps) => {
  const {
    question: { answerField, checkboxes },
    answersState,
  } = props;

  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    pathOr([], [answerField, 'value', PRICE_OPTIONS_FIELD], answersState),
  );

  const options = useMemo(
    () => (checkboxes ? checkboxes.map(e => ({ label: e.title, value: e.answerField })) : []),
    [checkboxes],
  );

  const handleSelect = useCallback((selected: string[]) => setSelectedOptions(selected), []);

  return {
    selectedOptions,
    handleSelect,
    options,
  };
};
